import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { BackstageLoggerDefaultArgs } from '../../../constants';
import * as D from '../../../deps';
import { withAlbumButtonControls } from '../../common/AlbumButtonControls';

export const AlbumSidebarButtons = props => {
  const {
    pandoraId,
    hasInteractive,
    isPaused,
    isPlayingCurrently,
    onDemandIsEnabled,
    sourceCardMenuItems,
    inCollection,
    playOnClick,
    pauseOnClick,
    removeMusicClick,
    addToMusicClick,
    triggerStartArtistStationCoachmark,
    onShareClick,
  } = props;

  const addToMusicOnClick = !inCollection ? addToMusicClick : noop;
  const disabledButtons = [D.ButtonRowType.CREATE_STATION];

  if (!hasInteractive) {
    disabledButtons.push(D.ButtonRowType.PLAY);
  }

  const integrationData = {
    ...BackstageLoggerDefaultArgs.controlBar,
    pandoraId,
  };

  return (
    <D.AppContextIntegrationData data={integrationData}>
      <D.ButtonRowWithLogger
        playOnClick={!isPlayingCurrently || isPaused ? playOnClick : noop}
        pauseOnClick={isPlayingCurrently && !isPaused ? pauseOnClick : noop}
        removeFromMusicOnClick={inCollection ? removeMusicClick : noop}
        disabledButtons={disabledButtons}
        createStationOnClick={triggerStartArtistStationCoachmark}
        shareOnClick={onShareClick}
        isSidebar={true}
        buttonTextType={D.ButtonTextType.PLAY_ALBUM}
        ellipsisSourceCardMenuItems={sourceCardMenuItems}
        addToMusicOnClick={onDemandIsEnabled ? addToMusicOnClick : null}
        hiddenButtons={!onDemandIsEnabled ? [D.ButtonRowType.MORE] : []}
      />
    </D.AppContextIntegrationData>
  );
};

AlbumSidebarButtons.propTypes = {
  pandoraId: PropTypes.string,
  hasInteractive: PropTypes.bool,
  isPaused: PropTypes.bool,
  isPlayingCurrently: PropTypes.bool,
  onDemandIsEnabled: PropTypes.bool,
  sourceCardMenuItems: PropTypes.object,
  inCollection: PropTypes.bool,
  playOnClick: PropTypes.func,
  pauseOnClick: PropTypes.func,
  removeMusicClick: PropTypes.func,
  addToMusicClick: PropTypes.func,
  triggerStartArtistStationCoachmark: PropTypes.func,
  onShareClick: PropTypes.func,
};

export function mapStateToProps(state, ownProps) {
  return {
    isPaused: !D.getInDomain('playback.utils.isAudioPlaying', false)(state),
    isPlayingCurrently: D.getInDomain('playback.utils.isSourcePlayingCurrently', false)(
      state,
      ownProps.pandoraId,
    ),
    showPremiumAccess: D.Utils.Listener.showPremiumAccess(state),
    onDemandIsEnabled: D.Utils.Listener.hasPremiumFeatures(state),
    sourceCardMenuItems: D.getSourceCardMenuItems({
      state,
      pandoraId: ownProps.pandoraId,
      pandoraType: D.PandoraTypes.ALBUM,
      isBackstagePage: true,
    }),
    inCollection: D.getInDomain('collection.utils.isPandoraIdInCollection', false)(
      state,
      ownProps.pandoraId,
    ),
  };
}

const enhance = compose(withAlbumButtonControls, connect(mapStateToProps));

export default enhance(AlbumSidebarButtons);
